// Global Error Handler

import { ErrorHandler, Injectable } from '@angular/core';

import { CommonUtility } from './../../utils/commonUtils';
import { MonitoringService } from '../app-monitoring-service/app-monitoring.service';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler extends ErrorHandler {
  constructor(private readonly monitoringService: MonitoringService) {
    super();
  }

  /**
   * To log errors in a specific format on console.
   * @param error Errors in application
   */
  override handleError(error: any) {
    const err: Error = {
      name: error.name ? error.name : '',
      message: error.message ? error.message : error.toString(),
      stack: error.stack ? error.stack : '',
    };

    if (!CommonUtility.isProdEnv()) {
      // Log  the error
      console.error(error);
    }

    if (!CommonUtility.isLocalhost()) {
      this.monitoringService.logException(err);
    }
  }
}
